import { Resource } from "@redotech/redo-model/localization/resource";
import GrayModalCloseButton from "@redotech/redo-web/arbiter-icon/gray-close-x.svg";
import {
  Button,
  ButtonBorder,
  ButtonSize,
  ButtonTheme,
} from "@redotech/redo-web/button";
import { Flex } from "@redotech/redo-web/flex";
import ReturnInStoreIcon from "@redotech/redo-web/icon-old/building-02.svg";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const ReturnInStore = memo(function ReturnInStore({
  onAccept,
  onDecline,
  onCancel,
  copyResource,
}: {
  onAccept(): void;
  onDecline(): void;
  onCancel(): void;
  copyResource: Resource;
}) {
  return (
    <>
      <Flex align="center" justify="space-between">
        <ReturnInStoreIcon height={52} width={52} />
        <GrayModalCloseButton
          onClick={onCancel}
          style={{ cursor: "pointer" }}
        />
      </Flex>
      <Flex dir="column" gap="4xl">
        <Flex dir="column" gap="xxs">
          <Text fontSize="lg" fontWeight="semibold">
            Want to return in-store?
          </Text>
          <Text fontSize="sm" fontWeight="thin" textColor="tertiary">
            You can choose to bring your item right into the store and save the
            time of shipping.
          </Text>
        </Flex>
        <Flex dir="column" gap="lg">
          <Button
            onClick={onAccept}
            size={ButtonSize.LARGE}
            theme={ButtonTheme.PRIMARY}
          >
            {copyResource.IN_STORE_RETURN_TEXT}
          </Button>
          <Button
            border={ButtonBorder.LIGHT}
            onClick={onDecline}
            size={ButtonSize.LARGE}
            theme={ButtonTheme.OUTLINED}
          >
            Ship back to us
          </Button>
        </Flex>
      </Flex>
    </>
  );
});
